// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1IEVz","buttons":"styles_buttons__2ifDH"};